export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6337.ccd1cc8b.jpg";